import {
  InMemoryCache,
  ApolloClient
} from 'apollo-boost'
import { HttpLink } from 'apollo-link-http'
import { ApolloLink, from } from 'apollo-link'

import { HOST } from './config'

const httpLink = new HttpLink({
  uri: `${HOST}/supersaiyajapi`,
})

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('token')
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null,
    }
  }))

  return forward(operation)
})

const client = new ApolloClient({
  link: from([
    authMiddleware,
    httpLink,
  ]),
  cache: new InMemoryCache(),
})

export default client
